import { Modifiers } from '../../helpers/getModifiers';
export var acceptableProps = Modifiers.allAcceptableArrayProps;
export var textareaProps = function (theme) { return ({
    fontFamily: theme.brand.fontFamily,
    color: theme.neutrals.gray8,
    bgColor: theme.neutrals.pureWhite,
    bRadius: theme.borderRadius.xs,
    height: 160,
    width: '100%',
    bWidth: theme.borderWidth.hairline,
    bColor: theme.neutrals.gray4,
    bStyle: 'solid',
    fontSize: theme.fontSize.xxs,
    fontStyle: 'normal',
    lineHeight: theme.brand.lineHeight.lg,
    fontWeight: theme.brand.fontWeight.medium,
    hasError: false,
    errorBColor: theme.brand.color.negative.pure,
}); };
